import axios from 'axios'

const credentialServiceBaseUrl = process.env.VUE_APP_CREDENTIAL_SERVICE_BASE_URL; //'https://credservice.sandbox.sundevil.infotrust.com/jsonrpc';
const automationServiceBaseUrl = process.env.VUE_APP_AUTOMATION_SERVICE_BASE_URL;

export default {
  async post(endpoint, data, accessToken, modalObject) {
    const requestBody = {
      orgid: 'infotrust',
      ...data
    };
    if (endpoint.match(/google\.submitOAuthSecret|credentials\.delete/)) {
      delete requestBody.orgid;
    }
    const apiCall = await axios.post(
      credentialServiceBaseUrl,
      {
        "method": endpoint,
        "params": requestBody
      },
      { 
        headers: {
          'Content-Type': 'application/json',
          'Authorization' : 'Bearer '+accessToken
        }
      }
    );
    if (apiCall?.data?.error) {
      console.log({
        endpoint,
        data
      });
      if (modalObject?.message) {
        modalObject.message.warning(`Endpoint: ${endpoint} - ${apiCall.data.error.code}: ${apiCall.data.error.message}`, { duration: 10000 });
      } else {
        console.error(apiCall.data.error);
      }
    }
    return apiCall.data;
  },
  async postAutomation(endpoint, data, accessToken, modalObject) {
    const requestBody = {
      orgid: 'infotrust',
      ...data
    };
    if (endpoint.match(/jobs\.(get|archiveJob|configureJob|startStage)|jobstorage\./)) {
      delete requestBody.orgid;
    }
    const apiCall = await axios.post(
      automationServiceBaseUrl,
      {
        "method": endpoint,
        "params": requestBody
      },
      { 
        headers: {
          'Content-Type': 'application/json',
          'Authorization' : 'Bearer '+accessToken
        }
      }
    );
    if (apiCall?.data?.error) {
      console.log({
        endpoint,
        data
      });
      if (modalObject?.message) {
        modalObject.message.warning(`Endpoint: ${endpoint} - ${apiCall.data.error.code}: ${apiCall.data.error.message}`, { duration: 10000 });
      } else {
        console.error(apiCall.data.error);
      }
    }
    return apiCall.data;
  }
}